module.exports = __webpack_public_path__ + "img/03-2-1自动处理.34ed21b0.svg";